
import { defineComponent, PropType } from 'vue';

export default defineComponent({ props: { fields: Array as PropType<[string, string][]> } });
